import { Box, ButtonBase } from "@mui/material";

import styles from "./styles";

interface Props {
  hideView: boolean;
  hideLeftBorder: boolean;
  hideRightBorder: boolean;
  clickArrow: () => void;
}

const CollapsibleButton = ({
  hideView,
  hideLeftBorder,
  hideRightBorder,
  clickArrow,
}: Props) => {
  return (
    <ButtonBase
      sx={[
        styles.arrowContainer,
        hideLeftBorder && styles.hideBorderLeft,
        hideRightBorder && styles.hideBorderRight,
      ]}
      onClick={clickArrow}
    >
      <Box
        sx={styles.arrowIcon}
        component="i"
        className={
          hideView
            ? "fa-thin fa-arrow-left-from-line"
            : "fa-thin fa-arrow-right-from-line"
        }
      />
    </ButtonBase>
  );
};

export default CollapsibleButton;
